import React from 'react';
import PropTypes from 'prop-types';

const SearchFormHeader = ({
    formType,
    headerTitle,
}) => {

    let formTypeTitle = '';

    if (formType === 'allResults') {
        formTypeTitle = 'All Collections'
    } else if (formType === 'courtaction')  {
        formTypeTitle = ''
    } else {
        formTypeTitle = formType.charAt(0).toUpperCase() + formType.substr(1) + ' Collection'
    }

    return(
        <div className="row">
            <div className="col-md-12">
                <h3 className="formTitle">Search {headerTitle} {formTypeTitle} </h3>
            </div>
        </div>
    )
};

SearchFormHeader.propTypes = {
    formType: PropTypes.string,
    headerTitle: PropTypes.string,
}

export default SearchFormHeader;


// WEBPACK FOOTER //
// ./src/components/searchForm/components/searchFormHeader.js